/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal, Fade, makeStyles, IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(87, 61, 168, 0.12)',
  },
  paper: {
    position: 'relative',
    width: '100%',
    maxWidth: '600px',
    height: 'auto',
    outline: 0,
    boxShadow: '0 15px 12px 0 rgba(0, 0, 0, 0.22), 0 19px 38px 0 rgba(0, 0, 0, 0.25)',
    borderRadius: '16px',
    '@media (max-width:800px)': {
      overflow: 'auto',
    },
    '@media (max-width:959px)': {
      width: '80vw',
    },
  },
  buttonClose: {
    position: 'absolute',
    zIndex: 1,
    top: '0',
    right: '0',
  },
}));

const StyledModal = ({ children, open, setOpen, papperStyle }) => {
  const classes = useStyles();
  return (
    <Modal hideBackdrop className={classes.modal} open={open} closeAfterTransition>
      <Fade in={open}>
        <div className={classes.paper} style={{...papperStyle}} >
          <IconButton
            className={classes.buttonClose}
            color="primary"
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon fontSize="small" color="action" />
          </IconButton>
          {children}
        </div>
      </Fade>
    </Modal>
  );
};

StyledModal.defaultProps = {
  children: <></>,
};

StyledModal.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default StyledModal;
